import { render } from "./PeriodicalContent.vue?vue&type=template&id=5008714c&scoped=true"
import script from "./PeriodicalContent.vue?vue&type=script&lang=js"
export * from "./PeriodicalContent.vue?vue&type=script&lang=js"

import "./PeriodicalContent.vue?vue&type=style&index=0&id=5008714c&lang=scss&scoped=true"

import exportComponent from "D:\\code\\newspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5008714c"]])

export default __exports__